module.exports = __webpack_public_path__ + "static/media/logo6.c5824f2e.png";